import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Full from '@/container/Full';
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '_home',
    component: Full,
    redirect:{name: 'home'},
    children:[
      {
        path: '',
        name: 'home',
        component: Home,
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('../views/aboutMore/About.vue')
      },
      {
        path: 'nameatl1',
        name: 'nameatl1',
        component: () => import('../views/aboutMore/nameatl1.vue')
      },
      {
        path: 'nameatl2',
        name: 'nameatl2',
        component: () => import('../views/aboutMore/nameatl2.vue')
      },
      {
        path: 'nameatl3',
        name: 'nameatl3',
        component: () => import('../views/aboutMore/nameatl3.vue')
      },
      {
        path: 'artical',
        name: 'artical',
        component: () => import('../views/artical.vue')
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('../views/contact.vue')
      },
      {
        path: 'artical1',
        name: 'artical1',
        component: () => import('../views/articalMore/artical1.vue')
      },
      {
        path: 'artical2',
        name: 'artical2',
        component: () => import('../views/articalMore/artical2.vue')
      },
      {
        path: 'artical3',
        name: 'artical3',
        component: () => import('../views/articalMore/artical3.vue')
      },
      {
        path: 'artical4',
        name: 'artical4',
        component: () => import('../views/articalMore/artical4.vue')
      },
      {
        path: 'artical5',
        name: 'artical5',
        component: () => import('../views/articalMore/artical5.vue')
      },
      {
        path: 'artical6',
        name: 'artical6',
        component: () => import('../views/articalMore/artical6.vue')
      },
      {
        path: 'artical7',
        name: 'artical7',
        component: () => import('../views/articalMore/artical7.vue')
      },
      {
        path: 'articalxu',
        name: 'articalxu',
        component: () => import('../views/articalMore/articalxu.vue')
      },
      {
        path: 'searchname',
        name: 'searchname',
        component: () => import('../views/articalMore/searchname.vue')
      },
      {
        path: 'changename',
        name: 'changename',
        component: () => import('../views/articalMore/changename.vue')
      },
      {
        path: 'aboutname',
        name: 'aboutname',
        component: () => import('../views/articalMore/aboutname.vue')
      },
      {
        path: 'personalCenter',
        name: 'personalCenter',
        component: () => import('../views/personalCenter')
      }
    ]
  },
  
  
]

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior: () => ({y: 0}),
  linkExactActiveClass: 'active',
})

export default router
